import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, formContext, useFieldContext } =
	createFormHookContexts();

export const { useAppForm, useTypedAppFormContext } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {},
	formComponents: {},
});

export const defaultSettingsValues = {
	category_ids: [] as number[],
	max_enrollments: 0,
	price_is_free: true,
	price_amount: 0,
};
